module.exports = __webpack_public_path__ + "static/img/正常22.788729a5.png";